import { z } from 'zod';

export const uuid = z.string().uuid();
export const email = z.string().trim().toLowerCase().email().max(254);
export const isoDate = z.string().datetime({ offset: true });
export const currency = z.enum(['EUR']);
export const locale = z.enum(['fr', 'en']);
export type Locale = z.infer<typeof locale>;

/** Amounts are always integer minor units (cents). */
export const amountCents = z.number().int().nonnegative();

export const paginationQuery = z.object({
  limit: z.coerce.number().int().min(1).max(200).default(50),
  cursor: z.string().optional(),
});

export const apiError = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
  }),
});
export type ApiError = z.infer<typeof apiError>;
